import { logger } from '@/modules/common/logging/logger';

import { ISnackbarService } from './ISnackbarService';

export class SnackbarServiceLogDecorator implements ISnackbarService {
  private decoree: ISnackbarService;

  constructor(decoree: ISnackbarService) {
    this.decoree = decoree;
  }

  showMessage(message: string): void {
    const start = this.logStart('showMessage');
    this.decoree.showMessage(message);
    this.logEnd('showMessage', start);
  }

  // private utility methods

  private logStart(methodName: string): number {
    const start: number = performance.now();
    logger.info(`Start -> ${methodName}`);
    return start;
  }

  private logEnd(methodName: string, start: number): void {
    logger.info(`End -> ${methodName} (${(performance.now() - start).toFixed(2)}ms)`);
  }
}
